import React, { useEffect, useState } from 'react';
/**
 * Otp time component
 * @param {*} param0
 */
const OtpTimer = ({ delay = 60, setCounterFlag }) => {
    const [counter, setCounter] = useState(delay);

    useEffect(() => {
        counter > 0
            ? setTimeout(() => setCounter(counter - 1), 1000)
            : setCounterFlag(false);
    }, [counter, setCounterFlag]);

    return (
        <div className="inf-coundown-wrapper">
            <div>
                Please wait {counter} second{counter > 1 && 's'} to resend the
                code again.
            </div>
        </div>
    );
};

export default OtpTimer;
